<template>
    <div class="d-flex align-start">
        <v-list-item-title :title="offer.name" data-cy="hotel-link" class="hotel-link d-inline-block text-truncate">
            <a v-if="infoInNewTab" :href="$router.resolve(hotelPageLink).href" target="_blank"> {{ offer.name }} </a>
            <nuxt-link v-else-if="$route.name === 'hotels'" no-prefetch :to="hotelPageLink">
                {{ offer.name }}
            </nuxt-link>
            <span v-else>
                {{ offer.name }}
            </span>
        </v-list-item-title>
        <hotel-stars class="ms-2" :hotel="offer" />
    </div>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'
    import HotelStars from '~src/components/hotels/snippets/hotelStars.src'

    @Component({components: {HotelStars}})
    export class HotelNameAndRating extends Vue {
        @Prop({required: true}) offer
        @Prop({required: true}) infoInNewTab
        @Prop({required: true}) hotelPageLink
    }

    export default HotelNameAndRating
</script>
